import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type DarkKpiRow = {
  name: string;
  obj: number;
  aprobados: number;
  cumplimiento: number;
};

export type DarkKpiSummary = {
  obj: number;
  aprobados: number;
  cumplimiento: number;
};

@Component({
  selector: 'app-dark-kpi-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dark-kpi-card.component.html',
  styleUrl: './dark-kpi-card.component.scss',
})
export class DarkKpiCardComponent {
  @Input() title = 'Radar de Cumplimiento';
  @Input() subtitle = 'Última actualización';
  @Input() timestamp = new Date().toLocaleString('es-CO');

  @Input() summary: DarkKpiSummary = {
    obj: 12450,
    aprobados: 10980,
    cumplimiento: 0.882,
  };

  @Input() rows: DarkKpiRow[] = [
    { name: 'Ejecución Atún lineal', obj: 2176, aprobados: 2313, cumplimiento: 1.063 },
    { name: 'Participación Café lineal', obj: 3032, aprobados: 2995, cumplimiento: 0.988 },
    { name: 'Película básica promo', obj: 980, aprobados: 901, cumplimiento: 0.919 },
    { name: 'Exhibición cabecera', obj: 770, aprobados: 641, cumplimiento: 0.832 },
    { name: 'Planograma refrescos', obj: 1200, aprobados: 963, cumplimiento: 0.802 },
  ];

  get completionPercent(): number {
    return Math.max(0, Math.min(100, this.summary.cumplimiento * 100));
  }

  rowPercent(value: number): number {
    return Math.max(0, Math.min(100, value * 100));
  }
}
